module.exports = __webpack_public_path__ + "img/map-marker-active-lh.a4177209.png";